import { render, staticRenderFns } from "./lkuPinjamanBlmLunas.vue?vue&type=template&id=2a833567&"
import script from "./lkuPinjamanBlmLunas.vue?vue&type=script&lang=js&"
export * from "./lkuPinjamanBlmLunas.vue?vue&type=script&lang=js&"
import style0 from "./lkuPinjamanBlmLunas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports